import axios from "axios";
import store from "@/store";
import Vue from "vue";
import Cookie from "js-cookie";
import i18n from "./i18n";
import router from "../router/index";
// Request interceptor
axios.interceptors.request.use(
  request => {
    let token = store.getters["auth/token"];
    if (token) {
      if (request.params && request.params.export && request.params.download) {
        request.responseType = 'blob';
      } else {
        request.headers.common["Accept"] = "application/json";
      }
      request.headers.common["Authorization"] = `Bearer ${token}`;
    }

    const locale = null;
    if (locale) {
      request.headers.common["Accept-Language"] = locale;
    }

    return request;
  },
  error => {
    return Promise.reject(error);
  }
);

/// Response interceptor
axios.interceptors.response.use(
  response => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.config.responseType == "blob") {
      const url = window.URL.createObjectURL(new Blob([response.data],
        { type: response.data.type }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download",
          response.headers["content-disposition"].split("filename=")[1]);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    return response.data;
  },
  error => {
    const vm = new Vue({});
    if (error.response.status === 401) {
      Cookie.remove("ecs_user_jwt_token");
      router.push({ name: "Login" });
      return Promise.reject(error);
    }

    if (error.response.status === 403 || error.response.status === 404) {
      router.push({ name: error.response.status.toString() });
      return Promise.reject(error);
    }

    let msg = i18n.t(`error.default`);
    if (
      error.response.status === 422 &&
      error.response.data.error.code === 4220
    ) {
      let messages = error.response.data.error.message;
      let firstKey = Object.keys(messages)[0];
      let firstValue = messages[firstKey][0];
      let part = firstValue.slice(
        firstValue.indexOf(".") + 1,
        firstValue.length
      );
      const key = `error.validation.${firstKey}.${part}`;
      // Fallback to raw backend message when no translation exists (e.g. custom Vietnamese messages)
      const hasTranslation = i18n.te(key) || i18n.te(key, i18n.fallbackLocale);
      msg = hasTranslation ? i18n.t(key) : firstValue;
    } else {
      if (error.response.data.error.code) {
        msg = i18n.t(`error.${error.response.data.error.code}`);
      }
    }
    vm.$bvToast.toast(msg + "!", {
      title: i18n.t(`error.error`),
      noCloseButton: false,
      autoHideDelay: 10000,
      appendToast: true,
      toaster: "b-toaster-top-center",
      variant: "danger",
      solid: true
    });
    return Promise.reject(error);
  }
);

export default axios;
